{
  "blocks": [
    {
      "id": "test-karyotype",
      "kind": "test",
      "tags": ["testing", "her", "his", "both-partners", "genetic-screening"],
      "title": "Karyotype",
      "subtitle": "Examines chromosome number and structure for both partners",
      "icon": "🧬",
      "body": {
        "testName": "Karyotype",
        "category": "genetic",
        "whatItMeasures": "Examines chromosome number and structure. Identifies translocations, inversions, or missing/extra chromosomes that cause recurrent loss or failed implantation.",
        "howItWorks": "Blood draw: lab cultures white blood cells and photographs chromosomes under a microscope. Takes longer than standard blood tests.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5 min draw"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "Both partners if indicated"
          },
          {
            "kind": "results",
            "value": "2-4 weeks"
          }
        ],
        "resultTypes": [
          {
            "label": "Typical karyotype",
            "meaning": "The lab sees the expected chromosome number and structure in the cells analyzed.",
            "whatToExpect": "This lowers concern for large visible chromosome rearrangements, but it does not rule out smaller genetic variants."
          },
          {
            "label": "Balanced rearrangement",
            "meaning": "A chromosome rearrangement is present, but no major genetic material appears missing or duplicated in that person.",
            "whatToExpect": "The carrier may be healthy but have higher risk of miscarriage or embryos with unbalanced chromosomes. Genetic counseling and PGT-SR may be discussed."
          },
          {
            "label": "Unbalanced or extra/missing chromosome",
            "meaning": "The lab sees missing, extra, or visibly rearranged chromosome material.",
            "whatToExpect": "This needs genetics review because implications vary widely by chromosome, mosaicism, and whether the finding is constitutional or acquired."
          },
          {
            "label": "Mosaic or inconclusive",
            "meaning": "Only some cells show a finding, or the sample does not produce a confident answer.",
            "whatToExpect": "Your clinician may recommend repeat testing, a different tissue, or genetic counseling before using the result for fertility planning."
          }
        ],
        "turnaroundTime": "2-4 weeks",
        "costRange": {
          "low": 300,
          "high": 800
        },
        "atHome": false,
        "clinicRequired": false,
        "dataPoints": [],
        "section": "genetic-screening"
      },
      "sources": [
        {
          "title": "Recurrent pregnancy loss: a committee opinion",
          "authors": "Practice Committee of the American Society for Reproductive Medicine",
          "journal": "ASRM Practice Committee",
          "year": 2026,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/recurrent-pregnancy-loss-a-committee-opinion-2026/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "ESHRE guideline: recurrent pregnancy loss",
          "authors": "ESHRE Guideline Group on RPL (Bender Atik R et al.)",
          "journal": "Human Reproduction Open",
          "year": 2023,
          "url": "https://academic.oup.com/hropen/article/2023/1/hoad002/7034139",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 4
    }
  ],
  "relationships": [],
  "localeVariants": []
}
